import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
	FreudButtonModule,
	FreudInputNumberModule,
	FreudSelectModule,
	FreudTooltipModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { AppointmentRecurrrency } from './appointment-recurrency.component';

@NgModule({
	declarations: [AppointmentRecurrrency],
	imports: [
		CommonModule,
		TranslateModule.forChild(),
		FreudSelectModule,
		ReactiveFormsModule,
		FormsModule,
		FreudButtonModule,
		FreudInputNumberModule,
		FreudTooltipModule,
	],
	exports: [AppointmentRecurrrency],
	providers: [],
})
export class AppointmentRecurrrencyModule {}
